<template>
  <div class="set-search-user">
    <div class="row">
      <div class="row-title">查找数量</div>
      <el-radio-group v-model="data.oneFlag" class="mTop10">
        <el-radio :label="true">单条</el-radio>
        <el-radio :label="false">多条</el-radio>
      </el-radio-group>
    </div>
    <div class="row">
      <div class="row-title">设置筛选条件</div>
      <div style="margin-top: 10px">从组织架构中获取用户信息</div>
      <div class="row-body">
        <condition-list
          ref="conditionList"
          :conditions="data.filters"
          :search-sheet="fakeSheet"
          :workflow-var-list="groupList"
          from="workflow_search"
          :app-roles="appRoles"
          :company-roles="companyRoles"
        ></condition-list>
      </div>
    </div>
  </div>
</template>

<script>
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import mixin from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/mixin"
import { getRoles } from "@/api/appManage/role"
import { getCompanyRolesWithNum } from "@/api/userCenter/company"

export default {
  name: "set-search-user",
  components: { ConditionList },
  props: {
    data: Object,
    extra: Object,
    groupList: Array,
    appId: String
  },
  mixins: [mixin],
  data() {
    return {
      appRoles: [],
      companyRoles: []
    }
  },
  computed: {
    companyId() {
      return this.$store.getters.userInfo.companyId
    },
    fakeSheet() {
      let companyId = this.companyId
      return {
        controls: [
          { name: "人员", _cid: "id", _type: "staff" },
          { name: "姓名", _cid: "n", _type: "text" },
          { name: "手机号", _cid: "tel", _type: "text" },
          { name: "部门", _cid: `cs.${companyId}.dptids`, _type: "department" },
          { name: "职位", _cid: `cs.${companyId}.pos`, _type: "text" },
          { name: "汇报对象", _cid: `cs.${companyId}.sup`, _type: "staff" },
          { name: "是否停用", _cid: `cs.${companyId}.gone`, _type: "boolean" },
          { name: "应用角色", _cid: `rids`, _type: "ref" },
          { name: "企业角色", _cid: `crids`, _type: "ref" }
        ]
      }
    }
  },
  created() {
    this._.flatten(this.data.filters).forEach(t => this.transOldObjArr(t.varItems))
    this.getRoles()
  },
  methods: {
    getRoles() {
      getRoles({ appId: this.appId }).then(appRoles => (this.appRoles = appRoles))
      getCompanyRolesWithNum().then(companyRoles => (this.companyRoles = companyRoles))
    }
  }
}
</script>

<style lang="scss" scoped>
.set-search-user {
  .row {
    font-size: 13px;
    padding-bottom: 15px;
    .row-title {
      font-weight: bold;
    }
    .row-tip {
      color: #9e9e9e;
    }
    .row-body {
      margin-top: 10px;
    }
  }
}
</style>
